<nav aria-label="...">
  <ul class="pagination pagination-sm pos-abs">
      <li>Showing {{startIndex}} to {{lastIndex}} of {{totalCount}} entries</li>
  </ul>
  <ul class="pagination pagination-sm justify-content-end" style="cursor: pointer;">
      <li class="page-item pointer" (click)="GoToPage(1)">
          <div class="page-link" tabindex="-1">First</div>
      </li>
      <li class="page-item pointer" [ngClass]="['page-item', (currentPageNumber===1 ? 'disabled' : '')]"
          (click)="ChangePageNumber(false)">
          <div class="page-link" tabindex="-1">Previous</div>
      </li>
      <li *ngFor="let item of pagesArray" #pageLi
          [ngClass]="['page-item', 'pageLi', 'pointer', (item===1 ? 'active' : '')]" id="pageLi{{item}}"
          (click)="TriggerAction($event, item)">
          <div class="page-link">{{item}}</div>
      </li>
      <li [ngClass]="['page-item', 'pointer', (currentPageNumber===totalPageCount ? 'disabled' : '')]"
          (click)="ChangePageNumber(true)">
          <div class="page-link">Next</div>
      </li>
      <li [ngClass]="['page-item', 'pointer', (currentPageNumber===totalPageCount ? 'disabled' : '')]"
          (click)="GoToPage(totalPageCount)">
          <div class="page-link">Last</div>
      </li>
  </ul>
</nav>
